import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { fmtDateTime } from "@/lib/assignments";
import { authorTone } from "./WorkspaceTabs";
import { roleLabel } from "./NotesTab";

const DOT = {
  create: "bg-brand", take: "bg-sky-500", status: "bg-amber-500", appointment: "bg-indigo-500", reassign: "bg-slate-500",
  note: "bg-emerald-500", attachment: "bg-slate-400", backfill: "bg-slate-400", activity_created: "bg-violet-500",
  activity_updated: "bg-violet-400", site_visit: "bg-orange-500", opportunity_link: "bg-teal-500",
};

export default function TimelineTab({ assignmentId, tick }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/assignments/${assignmentId}/timeline`).then(({ data }) => alive && setRows(data)).catch(() => alive && setRows([]));
    return () => { alive = false; };
  }, [assignmentId, tick]);

  if (rows === null) return <div className="py-6 text-center"><Loader2 className="mx-auto h-4 w-4 animate-spin text-brand" /></div>;
  if (rows.length === 0) return <p className="py-4 text-center text-xs text-slate-400">Nessun evento.</p>;
  return (
    <ol className="relative ml-2 space-y-3 border-l border-slate-200 pl-4" data-testid="timeline-list">
      {rows.map((h) => (
        <li key={h.id} className="relative" data-testid={`timeline-${h.id}`}>
          <span className={`absolute -left-[21px] top-1.5 h-2.5 w-2.5 rounded-full ring-2 ring-white ${DOT[h.action] || "bg-slate-300"}`} />
          <div className={`rounded-md border border-slate-100 border-l-4 px-3 py-2 ${authorTone(h.author_id)}`}>
            <div className="flex flex-wrap items-center justify-between gap-x-2 text-[11px] text-slate-500">
              <span className="font-semibold text-slate-700">{h.label}{h.action === "status" && h.old_status ? ` · ${h.old_status} → ${h.new_status}` : h.action === "create" ? ` · ${h.new_status}` : ""}</span>
              <span>{fmtDateTime(h.created_at)}</span>
            </div>
            <div className="text-[11px] text-slate-500">{h.author_name || "Sistema"}{h.author_role ? ` · ${roleLabel(h.author_role)}` : ""}{h.office_name ? ` · ${h.office_name}` : ""}</div>
            {h.note && <p className="mt-1 whitespace-pre-wrap break-words text-xs text-slate-800">{h.note}</p>}
          </div>
        </li>
      ))}
    </ol>
  );
}
